export const LEAD_ICON_SIZE = 12
export const AVATAR_SIZE = 14

export const labelSx = {
  fontFamily: 'var(--app-font-sans)',
  fontWeight: 'var(--app-font-weight-medium)',
  fontSize: 'var(--app-thought-font-size)',
  lineHeight: 'var(--app-thought-line-height)',
}

export const traceTypographySx = {
  fontFamily: 'var(--app-font-sans)',
  fontWeight: 'var(--app-font-weight-regular)',
  fontSize: 'var(--app-thought-font-size)',
  lineHeight: 'var(--app-thought-line-height)',
  letterSpacing: 0,
  color: 'text.secondary',
  width: '100%',
  boxSizing: 'border-box',
  whiteSpace: 'pre-line',
}

export const traceTypographyMediumSx = {
  fontFamily: 'var(--app-font-sans)',
  fontWeight: 'var(--app-font-weight-medium)',
  fontSize: 'var(--app-thought-font-size)',
  lineHeight: 'var(--app-thought-line-height)',
  letterSpacing: 0,
  color: 'text.tertiary',
  width: '100%',
  boxSizing: 'border-box',
  whiteSpace: 'pre-line',
}
